export const ANALYTICS_EVENT_CATEGORIES = {
  CLICK: 'clique',
  SEEN_OBJECT: 'objetoVisto',
};
